import React, { useEffect, useState } from "react";
import "../css/Header.css";
import logo from "../../assets/merchant-marvels.jpg";

export default function LandingHeader() {
  const [isSticky, setIsSticky] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // when scrolling down even a little, enable sticky style
      setIsSticky(window.scrollY > 10);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // close menu when going back to desktop
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 900) setMenuOpen(false);
    };
    window.addEventListener("resize", onResize, { passive: true });
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <header className={`siteHeader ${isSticky ? "isSticky" : ""}`}>
      <div className="headerInner">
        <a className="brand" href="/">
          {/* <span className="brandMark" />
          <span className="brandName">Slice</span> */}
          <img className="logo" src={logo} alt="Logo" />
        </a>

        

        <div className="right">
          {/* <a className="phone" href="tel:+10000000000"> */}
            <span className="phoneIcon"></span>
            <a href="/apply" className="landing-link-angle text-color-05 ">Get Started</a>
          {/* </a> */}

         
        </div>
      </div>

     
    </header>
  );
}
